(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('imask')) :
  typeof define === 'function' && define.amd ? define(['exports', 'imask'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.SvelteIMask = {}, global.IMask));
}(this, (function (exports, IMask) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var IMask__default = /*#__PURE__*/_interopDefaultLegacy(IMask);

  function fireEvent(el, eventName, data) {
    var e = document.createEvent('CustomEvent');
    e.initCustomEvent(eventName, true, true, data);
    el.dispatchEvent(e);
  }

  function initMask(el, opts) {
    var maskRef = opts instanceof IMask__default['default'].InputMask ? opts : IMask__default['default'](el, opts);
    return maskRef.on('accept', function () {
      return fireEvent(el, 'accept', maskRef);
    }).on('complete', function () {
      return fireEvent(el, 'complete', maskRef);
    });
  }

  function IMaskAction(el, options) {
    var maskRef = options && initMask(el, options);

    function destroy() {
      if (maskRef) {
        maskRef.destroy();
        maskRef = undefined;
      }
    }

    function update(options) {
      if (options) {
        if (maskRef) {
          if (options instanceof IMask__default['default'].InputMask) maskRef = options;else maskRef.updateOptions(options);
        } else maskRef = initMask(el, options);
      } else {
        destroy();
      }
    }

    return {
      update: update,
      destroy: destroy
    };
  }

  exports.imask = IMaskAction;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=svelte-imask.js.map
